<footer class="eu-footer" role="contentinfo" aria-label="Page Footer">
  <mat-divider></mat-divider>
  <mat-divider></mat-divider>
</footer>
